import { Routes } from '@angular/router';
import { ExhibitionsComponent } from './exhibitions.component';
import { ExhibitionItemComponent } from './exhibition-item.component';
var ɵ0 = {
    cmsCategory: 'exhibitions',
}, ɵ1 = {
    cmsCategory: 'exhibitions',
};
var routes = [
    {
        path: '',
        component: ExhibitionsComponent,
        data: ɵ0,
    },
    {
        path: ':id',
        component: ExhibitionItemComponent,
        data: ɵ1,
    },
];
var ExhibitionsRoutingModule = /** @class */ (function () {
    function ExhibitionsRoutingModule() {
    }
    return ExhibitionsRoutingModule;
}());
export { ExhibitionsRoutingModule };
export { ɵ0, ɵ1 };
